import React from "react";

interface FormFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => void;
  onBlur: (
    e: React.FocusEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => void;
  placeholder?: string;
  required?: boolean;
  touched?: boolean;
  error?: string;
  className?: string;
  minLength?: number;
  maxLength?: number;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  required = false,
  touched = false,
  error,
  className = "",
  minLength,
  maxLength,
}) => {
  return (
    <div className={className || undefined}>
      <label className="block f-16 font-weight-300 text[#989898] mb-4">
        {label} {required}
        {/* {label} {required && <span className="text-red-400">*</span>} */}
      </label>
      <input
        type="text"
        name={name}
        value={value}
        onChange={onChange as (e: React.ChangeEvent<HTMLInputElement>) => void}
        onBlur={onBlur as (e: React.FocusEvent<HTMLInputElement>) => void}
        placeholder={placeholder}
        minLength={minLength}
        maxLength={maxLength}
        aria-describedby={maxLength != null ? `${name}-char-count` : undefined}
        className={`w-full px-4 py-3 border-2 rounded-[27px] text-white bg-transparent focus:ring-2 focus:ring-[#E761A0]/50 focus:outline-none transition-all duration-200 placeholder-gray-500 ${
          touched && error
            ? "border-red-500/50 bg-red-500/10"
            : "border-[#E761A0] hover:border-[#E761A0]"
        }`}
      />
      {maxLength != null && (
        <p
          id={`${name}-char-count`}
          className="mt-1 text-sm text-gray-500"
          aria-live="polite"
        >
          {value.length} / {maxLength} characters
        </p>
      )}
      {touched && error && (
        <p className="mt-2 text-sm text-red-400 flex items-center gap-1">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

export default FormField;
